module.exports = __webpack_public_path__ + "static/media/coffee-1.82a846bb.jpeg";